import useSWR from "swr";
import axios, { endpoints, fetcher } from "src/utils/axios";
import type {
  FederationAssignment,
  FederationAssignmentCreate,
  FederationAssignmentList,
  FederationAssignmentOptions,
} from "src/types/federation-assignment";

export function useGetFederationAssignments(
  providerId: number,
  enabled: boolean,
  offset = 0,
) {
  return useSWR<FederationAssignmentList>(
    providerId > 0 && enabled
      ? [
          endpoints.provider.federation.assignments(providerId),
          { params: { offset, limit: 20 } },
        ]
      : null,
    fetcher,
    { keepPreviousData: false },
  );
}

export function useFederationAssignmentOptions(
  providerId: number,
  enabled: boolean,
  search = "",
  roleSearch = "",
  tournamentSearch = "",
) {
  return useSWR<FederationAssignmentOptions>(
    providerId > 0 && enabled
      ? [
          `${endpoints.provider.federation.assignments(providerId)}/options`,
          {
            params: {
              search,
              role_search: roleSearch,
              tournament_search: tournamentSearch,
            },
          },
        ]
      : null,
    fetcher,
    { keepPreviousData: false },
  );
}

export async function createFederationAssignment(
  providerId: number,
  payload: FederationAssignmentCreate,
) {
  const { data } = await axios.post<FederationAssignment>(
    endpoints.provider.federation.assignments(providerId),
    payload,
  );
  return data;
}

export async function revokeFederationAssignment(
  providerId: number,
  row: FederationAssignment,
) {
  const { data } = await axios.post<FederationAssignment>(
    `${endpoints.provider.federation.assignment(providerId, row.id)}/revoke`,
    { expected_revision: row.revision },
  );
  return data;
}
